import styled from 'styled-components';

export const ConversationStarterInviteStepperContainer = styled.div`
  margin: 48px 0;
`;
